import AntRadio from "antd/es/radio";
import styled from "styled-components";

const Radio = styled(AntRadio)<{ $size?: number }>`
  .ant-radio-inner {
    &::after {
      background: ${(p) => p.theme.colors.primaryBlue};
    }
    background: ${(p) => p.theme.colors.cardBgColor};
    border-color: ${(p) => p.theme.colors.lightestGrey};
  }
  .ant-radio-checked .ant-radio-inner {
    border-color: ${(p) => p.theme.colors.primaryBlue};
    background-color: transparent;
    &::after {
      transform: scale(0.5);
    }
  }
  .ant-radio.ant-radio-disabled .ant-radio-inner {
    border-color: ${(p) => p.theme.colors.disabledText};
  }
  ${(p) =>
    p.theme.isNewLook &&
    `
    .ant-radio:not(.ant-radio-checked):not(.ant-radio-disabled) .ant-radio-inner {
      border-color: ${p.theme.colors.checkboxBorderColor};
    }
    &:hover .ant-radio:not(.ant-radio-disabled) .ant-radio-inner {
      border-color: ${p.theme.colors.primaryBlue};
    }
  `}

  ${(p) => {
    return (
      p.$size &&
      `
    .ant-radio-inner:after {
      width: ${p.$size}px;
      height: ${p.$size}px;
      margin-top: -${p.$size / 2}px;
      margin-left: -${p.$size / 2}px;
    }
    .ant-radio-inner {
      width: ${p.$size}px;
      height: ${p.$size}px;
    }
  `
    );
  }}
`;

export default Radio;
